import SkeletonCustomRoutineItem from './SkeletonCustomRoutineItem';

interface SkeletonCustomRoutineListProps {
  count?: number;
  className?: string;
}

const DEFAULT_CUSTOM_ROUTINE_SKELETON_COUNT = 1;

const SkeletonCustomRoutineList = ({
  count = DEFAULT_CUSTOM_ROUTINE_SKELETON_COUNT,
  className = ''
}: SkeletonCustomRoutineListProps) => (
  <ul
    className={`w-full min-h-full h-fit max-h-full flex flex-col ~gap-6/10 items-center ~py-3/4 animate-pulse ${className}`}
    data-testid='skeleton-custom-routine-list'>
    {Array.from({ length: count }).map((_, index) => (
      <SkeletonCustomRoutineItem
        key={index}
        className={!index ? '~mt-9/10' : 'mt-0'}
      />
    ))}
  </ul>
);

export default SkeletonCustomRoutineList;
